<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索SKU" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">入库</el-button> -->
					<!-- <el-button type="danger" v-auth="'delAdmin'" @click="deleteAll" size="mini">批量删除</el-button> -->
					
					
					
					

				</template>
				
				<!-- 高级搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						
						
						<el-form-item label="SKU" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索SKU"></el-input>
						</el-form-item>
						
						<el-form-item label="工单号" class="mb-0">
							<el-input size="small" v-model="from.work_order" placeholder="搜索工单号"></el-input>
						</el-form-item>
						
						<el-form-item label="配件">
							<el-select v-model="from.parent" multiple  clearable size="small" filterable placeholder="请选择" style="width: 85%;">
								
								</el-option>
								<el-option v-for="item in plist" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="状态" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="已入库" :value="1"></el-option>
								<el-option label="维修员携带" :value="2"></el-option>
								<el-option label="已使用" :value="3"></el-option>
								
							</el-select>
						</el-form-item>
						
						<el-form-item label="是否保固" class="mb-0">
							<el-select v-model="from.is_gu" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="是" :value="1"></el-option>
								<el-option label="否" :value="0"></el-option>
								
							</el-select>
						</el-form-item>
						
						<el-form-item label="是否维修" class="mb-0">
							<el-select v-model="from.is_xiu" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="是" :value="1"></el-option>
								<el-option label="否" :value="0"></el-option>
								
							</el-select>
						</el-form-item>
						
						<el-form-item label="保养使用" class="mb-0">
							<el-select v-model="from.is_bao" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="是" :value="1"></el-option>
								<el-option label="否" :value="0"></el-option>
								
							</el-select>
						</el-form-item>
						
						<el-form-item label="使用设备">
							<el-select v-model="from.device_id" multiple  clearable size="small" filterable placeholder="请选择" style="width: 85%;">
								
								</el-option>
								<el-option v-for="item in delist" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					
						
						
						<el-form-item label="店铺">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="请选择" style="width: 85%;">
								</el-option>
								<el-option v-for="item in slist" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="领取时间"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="开始日期"
							      end-placeholder="结束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
			
			
			<div class="order_tabs">
				<el-tabs type="border-card" v-model="type" @tab-click="selOrderStatus">
				<el-tab-pane name="1" :label="'待处理 '+total_list.total_1"></el-tab-pane>
				<el-tab-pane name="2" :label="'已完成 '+total_list.total_2"></el-tab-pane>
				  
				 
				</el-tabs>
			</div>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" ref="table" :row-class-name="tableRowClassName" @expand-change="checkLog">
				
				<el-table-column type="selection" width="45" align="center">
				
				</el-table-column>
				
				<el-table-column align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column type="expand" label="明细" width="80">
				  <template slot-scope="v">
					  
					 <el-table
						:data="v.row.log"
						border
						max-height="350"
						style="width: 90%;margin-left: 5%;">
		
						
					
					<el-table-column align="center" prop="create_time" width="200" label="操作时间"></el-table-column>
						
						<el-table-column align="center"  prop="type_name"  label="操作">
							<template slot-scope="k">
								
								<span>{{k.row.type_name}}</span>
								<span v-if="k.row.type==5">
									- <el-tag type="info">
										{{v.row.remark}}
									</el-tag>
								</span>
								
								<span v-if="k.row.type==6">
									<el-tag type="warning">{{k.row.ad_name}}</el-tag>
									转移至
									<el-tag type="success">{{k.row.new_ins_name}}</el-tag>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center"  prop="ad_name"  label="操作员">
						</el-table-column>
			
					 							
					 </el-table>
					      
					 </template>
				</el-table-column>
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
				<el-table-column align="center" prop="name" width="70" label="配件图">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name" label="配件名称">
				</el-table-column>
				<el-table-column align="center" prop="sku" label="SKU">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" label="二维码">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.qr_code" 
						    :preview-src-list="[scope.row.qr_code]">
						  </el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name" width="170" label="条形码">
					<template slot-scope="scope">
						<el-image 
						    style="width: 140px; height: 40px"
						    :src="scope.row.bar_code" 
						    :preview-src-list="[scope.row.bar_code]">
						  </el-image>
					</template>
				</el-table-column> -->
				
				
			
				<el-table-column align="center" prop="status" label="状态" >
					<template slot-scope="v">
						<span class="text-warning" v-if="v.row.status==0">待入库</span>
						<span class="text-success" v-if="v.row.status==1">已入库</span>
						<span class="text-success" v-if="v.row.status==2">维修员携带</span>
						
						<span style="color: #999;" v-if="v.row.status==3">已使用</span>
						<span style="color: #999;" v-if="v.row.status==4">调货 - <el-tag type="info">{{v.row.remark}}</el-tag></span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="ins_name" label="维修员">
				</el-table-column>
				<el-table-column align="center" prop="shop_name" label="店铺">
				</el-table-column>
				
				<el-table-column align="center" prop="work_order" label="工单号">
				</el-table-column>
				
				<el-table-column align="center" prop="de_name" label="使用设备">
				</el-table-column>
				
				
				<el-table-column align="center" prop="name" label="是否保固">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.is_gu==1">是</span>
						<span v-if="v.row.is_gu==0">否</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="name" label="是否维修">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.is_xiu==1">是</span>
						<span v-if="v.row.is_xiu==0">否</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="name" label="保养配件">
					<template slot-scope="v">
						<span class="text-success" v-if="v.row.is_bao==1">是</span>
						<span v-if="v.row.is_bao==0">否</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center"  width="180" prop="get_time" label="领取时间">
				</el-table-column>
				<el-table-column prop="id" align="center" width="120" label="操作" v-if="type=='1'">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-if="scope.row.status==2" size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row,4)">确定使用</el-button>
							<el-button v-if="scope.row.status==3" @click="openModel(scope.row,7)" v-auth="'edit'" size="mini" plain type="success">填写工单</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
			
			<div class="scrollbar" :style="{ width: scrollbarWidth }" v-show="!layout.is_phone && showScrollbar" ref="scrollbar">
			  <div class="thumb" ref="thumb" @mousedown="onMouseDown"></div>
			</div>
		</el-footer>



		<el-dialog :title="form.type ==4 ? '确定使用' : '填写工单'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">

				<el-form-item label="SKU">
					{{form.sku}}
				</el-form-item>
				
				<el-form-item label="使用店铺" prop="shop_id">
					<el-select v-model="form.shop_id"  size="small" filterable placeholder="请选择" style="width: 85%;" clearable :disabled="form.type==7?true:false">
						
						<el-option v-for="item in slist" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="使用设备" prop="de_id">
					<el-select v-model="form.de_id"  size="small" filterable placeholder="请选择" style="width: 85%;" clearable :disabled="form.type==7?true:false">
						
						<el-option v-for="item in delist" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
			
				 
				<el-form-item  label="是否保固" prop="is_gu">
					<el-radio-group :disabled="form.type==7?true:false" v-model="form.is_gu" size="small">
						
						<el-radio class="ml-0"  :label="0" border>否</el-radio>
						<el-radio class="ml-0"  :label="1" border>是</el-radio>
						
					</el-radio-group> 
				</el-form-item>
				<el-form-item  label="是否维修" prop="is_xiu">
					<el-radio-group :disabled="form.type==7?true:false" v-model="form.is_xiu" size="small">
						
						<el-radio class="ml-0"  :label="0" border>否</el-radio>
						<el-radio class="ml-0"  :label="1" border>是</el-radio>
						
					</el-radio-group> 
				</el-form-item>
				
				
				
				<el-form-item  label="保养配件" prop="is_bao">
					<el-radio-group :disabled="form.type==7?true:false" v-model="form.is_bao" size="small">
						
						<el-radio class="ml-0"  :label="0" border>否</el-radio>
						<el-radio class="ml-0"  :label="1" border>是</el-radio>
						
					</el-radio-group> 
				</el-form-item>
				
			
				
				<el-form-item label="工单号" prop="work_order">
					<el-input v-model="form.work_order" type="text" placeholder="工单号" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
	
				
				

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="调货" :visible.sync="dhModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表单内容 -->
			<el-form :rules="rules_diaohuo" ref="form2" :model="form_diaohuo" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item label="调货配件" prop="num">
					<el-tag type="warning">
						<span v-if="form_diaohuo.type==1">{{form_diaohuo.sku}}({{form_diaohuo.name}})</span>
						<span v-if="form_diaohuo.type==2">批量操作</span>
					</el-tag>
				</el-form-item>
			
				
				<el-form-item label="调货备注" prop="remark">
					<el-input v-model="form_diaohuo.remark" type="textarea" placeholder="调货备注" clearable size="small" style="width: 85%;" :rows="5"></el-input>
				</el-form-item>
				
			
			
		
			</el-form>
		
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="dhModel = false">取 消</el-button>
				<el-button type="primary" @click="submitDh">确 定</el-button>
			</div>
		</el-dialog>
		
		
		
		<el-dialog title="打印条码" :visible.sync="printModel"
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表单内容 -->
			<el-form :rules="rulesprint" ref="formEdit" :model="printData" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				
				
				
				
				<el-form-item label="打印尺寸" prop="size">
					<el-radio-group   v-model="printData.size" size="small">
						<el-radio :label="1" border>100*100</el-radio>
						<el-radio :label="2" border>100*150</el-radio>
						
					</el-radio-group>
				</el-form-item>
				
				
				
			
				
			
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="printModel = false">取 消</el-button>
				<el-button type="primary" @click="submitPrint">确 定</el-button>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				dhModel: false,
				editIndex: -1,
				type:'1',
				//搜索数据
				from: {
					name: '',
					status:-1,
					parent:[],
					sku:'',
					work_order:'',
					ins_id:[],
					shop_id:[],
					device_id:[],
					is_gu:-1,
					is_xiu:-1,
					is_bao:-1,
					time:[],
				},
				auth_val: 'Productlog',
				preUrl: "data/productlogList", //列表地址
				delAllUrl: "data/delProductlogAll", //批量删除地址
				delUrl: "data/delProductlog", //删除单条地址
				addUrl: "data/ProLogChange", //添加/修改地址
				editStatusUrl:"data/editStatusProductlog",//修改状态地址

				tableData: [],
				form_diaohuo: {
					ids:'',
					remark:'',
					sku:'',
					name:'',
					type:1,
				},
				rules_diaohuo: {
					remark: [{
							required: true,
							message: "请输入调货备注",
							trigger: 'blur',
						},
				
					]
				
				},
				form: {
					id:0,
					shop_id:'',
					work_order:'',
					type:4,
					sku:'',
					is_gu:0,
					is_bao:0,
					is_xiu:0,
					de_id:''
				},
				rules: {
					shop_id: [{
							required: true,
							message: "请选择使用店铺",
							trigger: 'blur',
						},

					],de_id: [{
							required: true,
							message: "请选择使用设备",
							trigger: 'blur',
						},

					],
					

				},
				rulesprint:{
					
				},
				printData:{
					id:0,
					size:1,
					type:1
				},
				printModel: false,
				plist:[],
				slist:[],
				inslist:[],
				delist:[],
				rule_list: [],
				check_img_list:[],
				total_list:{
					total_1:0,
					total_2:0,
				}
					
					
				
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('PrologList');
		},
		methods: {
			selMore(command){
				if(command==1){
					this.openPrintModel(false,2)
				}else{
					this.DiaoHuo(false,2)
					
				}
				
			},
			selOrderStatus(){
				this.getList()
				//this.selOrderStatus()
			},
			tableRowClassName({row, rowIndex}) {
							return 'blue-row';
			 },
			openPrintModel(e,type){
				let id = []
				if(type==1){
					id.push(e.id)
				}else{
					if(this.ids.length==0){
						this.$message({
							message: '请先选择要操作的数据',
							type: 'error'
						});
						return false
					}
					id = this.ids
				}
				this.printData = {
					id:id,
					size:1,
					type:type
				}
				this.printModel = true
				
			},
			submitPrint(){
				// window.open('/admin/user/printCode?id=1','_blank')
				this.axios.post('/admin/user/printCode',
					this.printData
				, {
					token: true,
				}).then(res => {
					let all = res.data
					
					if(all.code==1){
						this.printModel = false
						 window.open('/admin/user/printBar?fp='+all.data.list.token,'_blank')
					}else{
						this.$message({
							message: '打印调用失败',
							type: 'error'
						});
					}
					
				}).catch(err => {
					// 失败
				})
			},
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 关闭模态框
					}
				})
			},
			submitDh() {
				
				this.$refs.form2.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						
							this.layout.loading = true;
							this.axios.post('/admin/data/dhMoreApi', this.form_diaohuo, {
								token: true,
								loading: true
							}).then(res => {
								
								
								let all = res.data
								if (all.code == 1) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
									this.getList()
									this.dhModel = false
								}
								
								
									
								this.layout.loading = false;
							}).catch(err => {
								this.layout.loading = false;
							})
							
						// 关闭模态框
					}
				})
			},
			DiaoHuo(e,type){
				let id = []
				if(type==1){
					id.push(e.id)
					this.form_diaohuo = {
						id:id,
						type:type,
						sku:e.sku,
						name:e.name,
						remark: '',
						
					}
				}else{
					if(this.ids.length==0){
						this.$message({
							message: '请先选择要操作的数据',
							type: 'error'
						});
						return false
					}
					this.form_diaohuo = {
						id:this.ids,
						type:type,
						sku:'',
						name:'',
						remark: '',
					}
				}
				
				this.dhModel = true
			},

			// 打开模态框
			openModel(e,type) {
				// 增加
				// 修改
				this.form = {
					id:e.id,
					shop_id: e.shop_id==0?'':e.shop_id,
					work_order:e.work_order,
					type:type,
					sku:e.sku,
					is_gu:e.is_gu,
					is_bao:e.is_bao,
					is_xiu:e.is_bao,
					de_id:e.de_id==0?'':e.de_id,
				}
								
				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},
			checkLog(row,expandedRows){
				if(row.is_check_msg==0){
					this.checkLogApi(row)
					
				}
			},
			
			checkLogApi(row){
					this.axios.post('/admin/data/checkProMsg',
						{id:row.id}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						if(all.code==1){
							row.is_check_msg = 1
							row.log = all.data.list
						}
						
						
			
						
					}).catch(err => {
						// 失败
						
					})
				
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.plist = list.plist
					this.slist = list.slist
					this.delist = list.delist

					this.layout.loading = false;
				}).catch(err => {
					// 失败
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					name: '',
					status:-1,
					parent:[],
					sku:'',
					work_order:'',
					ins_id:[],
					shop_id:[],
					device_id:[],
					is_gu:-1,
					is_xiu:-1,
					is_bao:-1,
					time:[],
				}
			
				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 选择图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
